
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 1.25A1.75 1.75 0 008.25 3v1.174a5.252 5.252 0 00-3.5 4.951V13.5L3 15.25v.875h14v-.875l-1.75-1.75V9.125c0-2.286-1.46-4.23-3.5-4.951V3A1.75 1.75 0 0010 1.25zM8.25 17a1.75 1.75 0 103.5 0h-3.5z","fill":"currentColor"}})])
          )
        }
      }
    